module.exports = __webpack_public_path__ + "img/uploadicon.cb4c3a54.svg";